import {defaultTheme} from '@stencil/build-theme';
import HappyAngleRightIcon from '@stencil/icons/src/HappyAngleRightIcon/HappyAngleRightIcon';

import {FlexCentered} from '../../../../CommonStyleUtils/dwebCommon.styles';
import * as S from './HomeStayGalleryAllImageHeader.styles';

const HomeStayGalleryAllImageHeader = ({
  overviewData = {title: '', name: '', id: 0, count: 0, media: []},
  gridType = 0,
  headerType = '',
  onCategorySelection = overviewData => {},
  handlerBackClick = () => {},
}) => {
  const {title = '', name = '', id} = overviewData;
  const totalCount = overviewData?.count || overviewData?.media?.length;

  return (
    <>
      {headerType === 'taggedMedia' ? (
        <S.CaptivateTaggedHeaderWrap>
          <FlexCentered>
            <S.RoundCircleWrapSpan onClick={handlerBackClick}>
              <S.LeftArrowGalleryTraveller />
            </S.RoundCircleWrapSpan>

            <S.CaptivateHeaderText>
              {title || name} ({totalCount})
            </S.CaptivateHeaderText>
          </FlexCentered>
        </S.CaptivateTaggedHeaderWrap>
      ) : (
        <S.CaptivateHeaderWrap>
          <FlexCentered>
            <S.CaptivateHeaderText>
              {title || name} ({totalCount})
            </S.CaptivateHeaderText>
          </FlexCentered>
          {totalCount - gridType > 0 && (
            <S.ViewMorePills
              onClick={() => {
                onCategorySelection(overviewData);
              }}
            >
              + {totalCount - gridType} more
              <HappyAngleRightIcon
                width="1rem"
                height="1rem"
                fill={defaultTheme.colors.goWhite.base}
                margin="0 0 0 1rem"
              />
            </S.ViewMorePills>
          )}
        </S.CaptivateHeaderWrap>
      )}
    </>
  );
};

export default HomeStayGalleryAllImageHeader;
